
// import React, { useEffect, useState, useCallback } from 'react';
// import axios from 'axios';

// export default function CommentsPanel({ baseUrl = '', tenantId, eventId, itemId }) {
//   const [list, setList] = useState([]);
//   const [text, setText] = useState('');
//   const [loading, setLoading] = useState(true);
//   const [submitting, setSubmitting] = useState(false);

//   const base = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;

//   const listUrl = itemId
//     ? `/api/events/${tenantId}/events/${eventId}/items/${itemId}/comments`
//     : `/api/events/${tenantId}/events/${eventId}/comments`;

//   // current user
//   let storedUser = {};
//   try {
//     const raw = localStorage.getItem('user');
//     if (raw && raw !== 'undefined') storedUser = JSON.parse(raw);
//   } catch {}
//   const userId = storedUser.id;

//   // LOAD
//   const load = useCallback(async () => {
//     setLoading(true);
//     try {
//       const { data } = await axios.get(`${base}${listUrl}`);
//       const rows =
//         Array.isArray(data?.comments) ? data.comments :
//         Array.isArray(data) ? data : [];
//       setList(rows);
//     } catch (e) {
//       console.error('Failed to load comments', e);
//       setList([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [base, listUrl]);

//   useEffect(() => { load(); }, [load]);

//   // POST
//   const submit = async (e) => {
//     e.preventDefault();
//     const body = text.trim();
//     if (!body) return;
//     setSubmitting(true);
//     try {
//       await axios.post(`${base}${listUrl}`, {
//         tenantid: tenantId,
//         eventid: eventId,
//         itemid: itemId || null,
//         userid: userId,
//         comment: body
//       });
//       setText('');
//       await load();
//     } catch (e) {
//       console.error('Failed to add comment', e);
//       alert(e?.response?.data?.message || e.message || 'Failed to add comment');
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <div className="comments-panel">
//       <h5 className="mb-3">Comments</h5>

//       <form onSubmit={submit} className="mb-3">
//         <div className="input-group">
//           <input
//             className="form-control"
//             placeholder="Add a comment…"
//             value={text}
//             onChange={(e) => setText(e.target.value)}
//           />
//           <button className="btn btn-primary" type="submit" disabled={submitting || !text.trim()}>
//             {submitting ? 'Submitting…' : 'Comment'}
//           </button>
//         </div>
//       </form>

//       {loading ? (
//         <div className="text-muted">Loading comments…</div>
//       ) : list.length === 0 ? (
//         <div className="text-muted">No comments yet.</div>
//       ) : (
//         <ul className="list-group">
//           {list.map((c) => (
//             <li key={c.id} className="list-group-item">
//               <div className="small text-muted">
//                 {c.username || `User #${c.userid}`} •{' '}
//                 {new Date(c.createdon).toLocaleString()}
//               </div>
//               <div>{c.comment}</div>
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// }



import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

export default function CommentsPanel({ baseUrl = '', tenantId, eventId, itemId }) {
  const [list, setList] = useState([]);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const base = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;

  const listUrl = itemId
    ? `/api/events/${tenantId}/events/${eventId}/items/${itemId}/comments`
    : `/api/events/${tenantId}/events/${eventId}/comments`;

  // current user
  let storedUser = {};
  try {
    const raw = localStorage.getItem('user');
    if (raw && raw !== 'undefined') storedUser = JSON.parse(raw);
  } catch {}
  const userId = storedUser.id;

  // LOAD
  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${base}${listUrl}`);
      const rows =
        Array.isArray(data?.comments) ? data.comments :
        Array.isArray(data) ? data : [];
      setList(rows);
    } catch (e) {
      console.error('Failed to load comments', e);
      setList([]);
    } finally {
      setLoading(false);
    }
  }, [base, listUrl]);

  useEffect(() => { load(); }, [load]);

  // POST
  const submit = async (e) => {
    e.preventDefault();
    const body = text.trim();
    if (!body) return;
    setSubmitting(true);
    try {
      await axios.post(`${base}${listUrl}`, {
        tenantid: tenantId,
        eventid: eventId,
        itemid: itemId || null,
        userid: userId,
        comment: body
      });
      setText('');
      await load();
    } catch (e) {
      console.error('Failed to add comment', e);
      alert(e?.response?.data?.message || e.message || 'Failed to add comment');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="comments-panel">
      <h5 className="mb-3">Comments</h5>

      <form onSubmit={submit} className="mb-3">
        <div className="input-group">
          <input
            className="form-control"
            placeholder="Add a comment…"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          <button className="btn btn-primary" type="submit" disabled={submitting || !text.trim()}>
            {submitting ? 'Submitting…' : 'Comment'}
          </button>
        </div>
      </form>

      {loading ? (
        <div className="text-muted">Loading comments…</div>
      ) : list.length === 0 ? (
        <div className="text-muted">No comments yet.</div>
      ) : (
        <ul className="list-group">
          {list.map((c) => (
            <li key={c.id} className="list-group-item">
              <div className="small text-muted">
                {c.username || `User #${c.userid}`} •{' '}
                {new Date(c.createdon).toLocaleString()}
              </div>
              <div>{c.comment}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}